module.exports = __webpack_public_path__ + "static/media/metamask-fox.c879a582.svg";